// import React, { useEffect, useRef, useState } from "react";
// import { Input } from "reactstrap";

// const AudioPlayer = (props) => {
//   const videoRef = useRef(null);
//   const audioRef = useRef(null);
//   const waveformRef = useRef(null);
//   const [currentEpoch, setCurrentEpoch] = useState(props.epochLength);
//   const [progress, setProgress] = useState(0);
//   const [duration, setDuration] = useState(null);


//   const handleWaveformClick = (event) => {
//     if (!audioRef.current || !waveformRef.current) return;
  
//     const rect = waveformRef.current.getBoundingClientRect();
//     const clickX = event.clientX - rect.left;
//     const clickPositionRatio = clickX / rect.width;
    
//     if (audioRef.current.duration) {
//       const newTime = clickPositionRatio * audioRef.current.duration;
//       audioRef.current.currentTime = newTime;
//       // audioRef.current.play();
//     }
//   };
  

//   const handleAudioPlay = () => {
//     if (videoRef.current) {
//       videoRef.current.play();
//     }
//   };

//   const handleAudioPause = () => {
//     if (videoRef.current) {
//       videoRef.current.pause();
//     }
//   };

//   const handleAudioEnded = () => {
//     if (videoRef.current) {
//       videoRef.current.pause();
//       videoRef.current.currentTime = 0; // Reset video to the beginning
//     }
//   };

//   useEffect(() => {
//     if (audioRef.current) {
//       audioRef.current.load();
//     }
//   }, [props.src]);

//   const handleTimeUpdate = () => {
//     if (audioRef.current) {
//       const currentTime = audioRef.current.currentTime;
//       const totalDuration = audioRef.current.duration;
//       if (totalDuration > 0) {
//         const newProgress = (currentTime / totalDuration) * 100;
//         setProgress(newProgress);
//       }
//       requestAnimationFrame(handleTimeUpdate);
//     }
//   };
  
//   const handleLoadedMetadata = () => {
//     if (audioRef.current) {
//       setDuration(audioRef.current.duration);
//     }
//   };

  
//   const hexToRgba = (hex, alpha) => {
//     let r = 0, g = 0, b = 0;
  
//     // Check for valid hex format
//     if (hex.startsWith("#")) {
//       if (hex.length === 4) {
//         r = parseInt(hex[1] + hex[1], 16);
//         g = parseInt(hex[2] + hex[2], 16);
//         b = parseInt(hex[3] + hex[3], 16);
//       } else if (hex.length === 7) {
//         r = parseInt(hex.slice(1, 3), 16);
//         g = parseInt(hex.slice(3, 5), 16);
//         b = parseInt(hex.slice(5, 7), 16);
//       }
//     }
  
//     return `rgba(${r}, ${g}, ${b}, ${alpha})`;
//   };



//   const generateTimeMarkers = () => {
//     if (!duration || duration <= 0) return null;
  
//     let totalMarkers = 10;
//     let stepSize = duration / totalMarkers;
  

//     if (stepSize > 0.9) stepSize = 2;
//     // else if (stepSize >= 1) stepSize = 20;
//     else if (stepSize > 0.3) stepSize = 1;
//     else if (stepSize > 0.1) stepSize = 0.5;
//     else stepSize = 0.1;
  
//     let markers = [];
//     let time = 0;
  
//     while (time <= duration) {
//       let roundedTime = Math.round(time * 10) / 10; // Ensure consistent rounding
  
//       // Ensure last marker always reaches the duration
//       if (time + stepSize > duration) roundedTime = duration;
  
//       const leftPosition = `${(roundedTime / duration) * 100}%`;
  
//       markers.push(
//         <div
//           key={roundedTime}
//           className="text"
//           style={{
//             position: "absolute",
//             left: leftPosition,
//             transform: "translateX(-50%)",
//             whiteSpace: "nowrap",
//           }}
//         >
//           {roundedTime}
//         </div>
//       );
  
//       time += stepSize; // Increment time using fixed step size
//     }
  
//     return markers;
//   };



//   const generateFrequencyMarkers = () => {
//     if (!waveformRef.current || !props.frequency_steps) return null;
  
//     const imgHeight = waveformRef.current.clientHeight;
//     const totalSteps = props.frequency_steps.length;
  
//     return props.frequency_steps.map((freq, index) => {
//       const topPosition = (index / (totalSteps )) * imgHeight + 12;
  
//       return (
//         <div
//           key={freq}
//           style={{
//             position: "absolute",
//             top: `${topPosition}px`,
//             left: 0,
//             fontSize: "12px",
//             // color: "white",
//             whiteSpace:'nowrap'
//           }}
//         >
//           {freq}
//         </div>
//       );
//     });
//   };


//   const generateColorFrequencyMarkers = () => {
//     if (!waveformRef.current || !props.color_bar) return null;
  
//     const imgHeight = waveformRef.current.clientHeight - 33;
//     const totalSteps = props.color_bar.length;
  
//     return props.color_bar.map((freq, index) => {
//       const topPosition = (index / (totalSteps )) * imgHeight + 36;
  
//       return (
//         <div
//           key={freq}
//           style={{
//             position: "absolute",
//             top: `${topPosition}px`,
//             right:-18,
//             // transform: "translateY(-50%)",
//             fontSize: "12px",
//             // color: "white",
//             whiteSpace:'nowrap'
//           }}
//         >
//           {freq} dB
//         </div>
//       );
//     });
//   };
  
  
  

//   return (
//     <div style={{ position: "relative", width: "100%", textAlign: "center" }}>
//       {props.showProperties === false && (
//         <div
//           className="d-flex grey-card_ align-items-center justify-content-between px-3 py-1 my-1"
//           style={{
//             position: "absolute",
//             top: -10,
//             zIndex: 9999,
//             overflow: "hidden",
//             width: "100%",
//           }}
//         >
//           <h6 className="mb-0 px-3 border-right d-flex align-items-center">
//             <p
//               className="notification-message mb-0"
//               style={{ display: "inline-block", whiteSpace: "nowrap" }}
//               title={props?.audioName}
//             >
//              {props?.audioName}
//             </p>
//           </h6>
//         </div>
//       )}

// <div>
// <div style={{ position: "relative", display: "flex" }}>
// {props.specView &&
//   <div style={{minWidth: "20px",  height: waveformRef.current?.clientHeight || "auto" }}>
//     {generateFrequencyMarkers()}
//   </div>}
//   <img
//     ref={waveformRef}
//     src={props.specView ? props?.spectrogram_url : props?.waveform_url}
//     style={{ maxWidth: "100%", display: "block", zIndex:'9'}}
//     alt="Waveform"
//     onClick={handleWaveformClick}
//   />
//   {props.specView &&
//   <div style={{minWidth: "20px",  height: waveformRef.current?.clientHeight || "auto" }}>
//     {generateColorFrequencyMarkers()}
//   </div>
// }
// </div>


// {!props.specView &&
// <div
//           style={{
//             position: "absolute",
//             top: 0,
//             left: `${progress}%`,
//             width: "3px",
//             height: waveformRef.current ? waveformRef.current.clientHeight : "100%",
//             backgroundColor: "var(--text-color)",
//             zIndex: 10,
//             transform: `translateX(${progress}%)`,
//             transition: "width 0.01s linear",
//           }}
//         />}
// {!props.specView &&
// <>
// {props.Groundtruth?.map((item, index) => {
//   const transparentColor = hexToRgba(item[5], props.value / 100);

//   return (
//     <div
//       key={index}
//       style={{
//         position: "absolute",
//         top: 0,
//         left: 0,
//         width: `${progress}%`,
//         height: waveformRef.current ? waveformRef.current.clientHeight : "100%",
//         background: transparentColor,
//         zIndex: 5,
//       }}
//       onClick={handleWaveformClick}
//     />
//   );
// })}
// </>}


// {/* {!props.specView &&
//   <>
//     {props.Groundtruth?.map((item, index) => {
//       const transparentColor = hexToRgba(item[5], 0.5);
//       const [start, end] = [item[0], item[1]]; // Assuming start and end times are in index 0 and 1
//       const left = (start / duration) * 100;
//       const width = ((end - start) / duration) * 100;

//       return (
//         <div
//           key={index}
//           style={{
//             position: "absolute",
//             top: 0,
//             left: `${left}%`,
//             width: `${width}%`,
//             height: waveformRef.current ? waveformRef.current.clientHeight : "100%",
//             background: transparentColor,
//             zIndex: 5,
//           }}
//         />
//       );
//     })}
//   </>
// } */}


// {/* {!props.specView && (
//   <>
//     {[
//       { start: 0.0, end: 0.3, color: "#ff000080" },
//       { start: 0.6, end: 1, color: "#00ff0080" },
//       { start: 1.5, end: 3, color: "#0000ff80" },
//     ].map((range, index) => (
//       <div
//         key={index}
//         style={{
//           position: "absolute",
//           top: 0,
//           left: `${(range.start / duration) * 100}%`,
//           width: `${
//             progress >= (range.end / duration) * 100
//               ? ((range.end - range.start) / duration) * 100
//               : (progress / 100) * duration > range.start
//               ? ((progress / 100) * duration - range.start) / duration * 100
//               : 0
//           }%`,
//           height: waveformRef.current
//             ? waveformRef.current.clientHeight
//             : "100%",
//           background: range.color,
//           zIndex: 5,
//           transition: "width 0.1s linear", // Smooth width expansion
//         }}
//       />
//     ))}
//   </>
// )} */}
// <div style={{ position: "relative", width: "89%", height: "40px", marginTop: "5px", margin:'auto' }}>
//           {generateTimeMarkers()}
//         </div>

// <div className="d-flex align-items-start flex-column">

// <div>
//         <audio
//           ref={audioRef}
//           // autoPlay
//           controls
//           onTimeUpdate={handleTimeUpdate}
//           onPlay={handleAudioPlay}
//           onPause={handleAudioPause}
//           onEnded={handleAudioEnded}
//           onLoadedMetadata={handleLoadedMetadata}
//         >
//           <source src={props.src} type="audio/wav" />
//           Your browser does not support the audio element.
//         </audio>
//       </div>

//           <div style={{textAlign:'left'}} className="pb-2 ps-1">
//             Ground truth
//           </div>
// <div className="py-2 d-a ps-1">
// {props.Groundtruth?.map((item, index) => (
//     <div
//     key={item[4]}
//       className="grey-card10 p-2 px-1 me-2"
//       style={{ minWidth: 80, position: "relative" }}
//     >
//       <div className="d-j-a">
//         <div
//           style={{
//             background: item[5],
//             padding: 7,
//             width: 5,
//             display: "inline-block",
//             borderRadius: 5,
//           }}
//         ></div>

//         <div className="h5 ms-2 mb-0"> {item[4]}</div>
//       </div>
//     </div>
//   ))
// }

//         {props.annotations && (
//           <div
//             className="d-flex align-items-center grey-card p-2 ms-2 pt-4"
//             style={{ minWidth: 120, position: "relative" }}
//           >
//             <div
//               style={{
//                 position: "absolute",
//                 fontSize: 12,
//                 top: 4,
//                 height: 10,
//                 left: 10,
//               }}
//             >
//               prediction
//             </div>
//             <div
//               style={{
//                 background:
//                   currentEpoch > 0
//                     ? props.annotations[currentEpoch][0][5]
//                     : props.annotations[0][5],
//                 padding: 7,
//                 width: 5,
//                 display: "inline-block",
//                 borderRadius: 5,
//               }}
//             ></div>
//             <div className="h4 ms-2">
//               {currentEpoch > 0
//                 ? props.annotations[currentEpoch][0][4]
//                 : props.annotations[0][4]}
//             </div>
//           </div>
//         )}
//       </div>
// </div>

// </div>

//       {props.epochLength > 1 && (
//         <div
//           className="d-flex grey-card align-items-center justify-content-between px-3 py-2 epoch"
//           style={{
//             position: "absolute",
//             bottom: 8,
//             right: 8,
//             zIndex: 9999,
//             overflow: "hidden",
//             width: 200,
//           }}
//         >
//           <div className="mx-3 my-2">
//             <label
//               htmlFor="customRange"
//               className="form-label"
//               style={{ fontSize: 10, position: "absolute", top: -7 }}
//             >
//               Epoch {currentEpoch} of {props.epochLength}
//             </label>
//             <Input
//               type="range"
//               className="form-range mt-2 pt-1"
//               min="0"
//               max={props.epochLength}
//               step={props.epochspacing ? props.epochspacing : 1}
//               id="customRange"
//               defaultValue={currentEpoch}
//               onChange={(e) => {
//                 setCurrentEpoch(e.target.value);
//               }}
//             ></Input>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AudioPlayer;




// import { useEffect, useRef, useState } from 'react';
// import WaveSurfer from 'wavesurfer.js';
// import RegionsPlugin from 'wavesurfer.js/dist/plugins/regions.esm.js';
// import SpectrogramPlugin from 'wavesurfer.js/dist/plugins/spectrogram.esm.js';
// import Hover from 'wavesurfer.js/dist/plugins/hover.esm.js'
// import TimelinePlugin from 'wavesurfer.js/dist/plugins/timeline.esm.js'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faPause, faPlay, faVolumeOff, faVolumeUp } from '@fortawesome/free-solid-svg-icons';

// const AudioPlayer = ({ audioUrl, value, Groundtruth }) => {
//   const waveformRef = useRef(null);
//   const spectrogramRef = useRef(null);
//   const wsRef = useRef(null);
//   const [duration, setDuration] = useState(0);
//   const [currentTime, setCurrentTime] = useState(0);
//   const [isPlaying, setIsPlaying] = useState(false);
//   const [isMuted, setIsMuted] = useState(false);
//   const [volume, setVolume] = useState(1);

//   const hexToRgba = (hex, alpha) => {
//     let r = 0, g = 0, b = 0;
  
//     if (hex.startsWith("#")) {
//       if (hex.length === 4) {
//         r = parseInt(hex[1] + hex[1], 16);
//         g = parseInt(hex[2] + hex[2], 16);
//         b = parseInt(hex[3] + hex[3], 16);
//       } else if (hex.length === 7) {
//         r = parseInt(hex.slice(1, 3), 16);
//         g = parseInt(hex.slice(3, 5), 16);
//         b = parseInt(hex.slice(5, 7), 16);
//       }
//     }
  
//     return `rgba(${r}, ${g}, ${b}, ${alpha})`;
//   };


  // useEffect(() => {
  //   if (!waveformRef.current || !audioUrl) return;

  //   const ws = WaveSurfer?.create({
  //     container: waveformRef.current,
  //     waveColor: 'rgba(209, 209, 209, 0.74)',
  //     progressColor: '#8d8c8cd0',
  //     url: audioUrl,
  //     sampleRate: 44100,
  //     dragToSeek: true,
  //     plugins: [
  //       TimelinePlugin.create(),
  //       Hover.create({
  //         lineColor: '#ff0000',
  //         lineWidth: 2,
  //         labelBackground: '#555',
  //         labelColor: '#fff',
  //         labelSize: '11px',
  //         formatTimeCallback: (time) => {
  //           const hours = Math.floor(time / 3600);
  //           const minutes = Math.floor((time % 3600) / 60);
  //           const seconds = Math.floor(time % 60);
  //           const pseudoMilliseconds = Math.floor((time % 1) * 100);
    
  //           return `${hours.toString().padStart(2, '0')}:` +
  //                  `${minutes.toString().padStart(2, '0')}:` +
  //                  `${seconds.toString().padStart(2, '0')}:` +
  //                  `${pseudoMilliseconds.toString().padStart(2, '0')}`;
  //         }
  //       }),
  //     ]
  //   });
    

//     wsRef.current = ws;

    

//     // ---------- time ------ //

//   ws.once('ready', () => {
//     setDuration(ws.getDuration());
//   });

//   ws.on('audioprocess', () => {
//     setCurrentTime(ws.getCurrentTime());
//   });



//     const regions = ws.registerPlugin(RegionsPlugin.create());
//     ws.registerPlugin(
//       SpectrogramPlugin.create({
//         container: spectrogramRef.current,
//         labels: true,
//         height: 250,
//         scale: 'mel',
//         frequencyMax: 8000,
//         frequencyMin: 0,
//         fftSamples: 1024,
//         labelsBackground: 'rgba(0, 0, 0, 0.1)'
//       })
//     );

//     // ws.once('decode', () => {    
//     //   const regionsData = Groundtruth?.map(item => ({
//     //     start: item[0],
//     //     end: item[1],
//     //     content: item[4],
//     //     color: hexToRgba(item[5], value / 100),
//     //     resize: false,
//     //     drag: false
//     //   }));
    
//     //   regionsData?.forEach(region => regions.addRegion(region));
//     // });



//     ws.on('decode', () => {
//       // Regions
//       regions.addRegion({
//         start: 0.00,
//         end: 0.77,
//         content: 'Laugh',
//         color: '#ff000070',
//         drag: false,
//         resize: false,
//       })
//       regions.addRegion({
//         start: 0.83,
//         end: 3.27,
//         content: 'Talk',
//         color: '#ffa50047',
//         resize: false,
//       })
//       regions.addRegion({
//         start: 3.31,
//         end: 3.51,
//         content: 'Cry',
//         color: '#00800054',
//         resize: false,
//       })
//       regions.addRegion({
//         start: 3.63,
//         end: 6.01,
//         content: 'Talk',
//         color: '#ffa50047',
//         resize: false,
//       })
//       regions.addRegion({
//         start: 6.05,
//         end: 6.25,
//         content: 'Cry',
//         color: '#00800054',
//         resize: false,
//       })
//         regions.addRegion({
//         start: 6.30,
//         end: 6.98,
//         content: 'Silence',
//         color: '#a52a2a4d',
//         minLength: 1,
//         maxLength: 10,
//         resize: false,
//       })
//     })
    

//     ws.on('finish', () => {
//       setIsPlaying(false);
//       ws.setTime(0);
//     });

//     return () => {
//       ws.destroy();
//     };
//   }, [audioUrl, value]);

//   const togglePlay = () => {
//     if (wsRef.current) {
//       wsRef.current.playPause();
//       setIsPlaying(!isPlaying);
//     }
//   };

//   const toggleMute = () => {
//     if (wsRef.current) {
//       if (isMuted) {
//         wsRef.current.setVolume(1); // Unmute
//       } else {
//         wsRef.current.setVolume(0); // Mute
//       }
//       setIsMuted(!isMuted);
//     }
//   };

//   const handleVolumeChange = (e) => {
//     const newVolume = parseFloat(e.target.value);
//     setVolume(newVolume);
//     if (wsRef.current) {
//       wsRef.current.setVolume(newVolume);
//     }
//   };


//   // --------------- time ----------- //

//   const formatTime = (time) => {
//     const hours = Math.floor(time / 3600);
//     const minutes = Math.floor((time % 3600) / 60);
//     const seconds = Math.floor(time % 60);
//     const milliseconds = Math.floor((time % 1) * 100);
  
//     if (hours > 0) {
//       return `${hours}:${minutes.toString().padStart(2, '0')}:` +
//              `${seconds.toString().padStart(2, '0')}:` +
//              `${milliseconds.toString().padStart(2, '0')}`;
//     } else if (minutes > 0) {
//       return `${minutes}:${seconds.toString().padStart(2, '0')}:` +
//              `${milliseconds.toString().padStart(2, '0')}`;
//     } else {
//       return `${seconds}:${milliseconds.toString().padStart(2, '0')}`;
//     }
//   };


//   return (
//     <div className='d-flex flex-column w-100 p-4 px-1'>
//       <div ref={waveformRef} id="waveform" style={{ width: '100%', maxHeight: '200px' }} className='my-4 pt-4'></div>
//       <div ref={spectrogramRef} id="spectrogram" style={{ width: '100%'}}></div>
//       <div className="mt-3 d-a justify-content-between w-100">
//         <div className='d-a'>
//         <button onClick={togglePlay} className='plain-button2 me-4'>{isPlaying ? <FontAwesomeIcon icon={faPause} /> : <FontAwesomeIcon icon={faPlay} />}</button>
//         <div className='d-a custom-hover'>
//         <button onClick={toggleMute} className='plain-button2'>{isMuted ? <FontAwesomeIcon icon={faVolumeOff} /> : <FontAwesomeIcon icon={faVolumeUp} />}</button>
//         <input 
//         className='custom-visible'
//           type="range" 
//           min="0" 
//           max="1" 
//           step="0.01" 
//           value={isMuted ? 0 : volume} 
//           onChange={handleVolumeChange} 
//           style={{ width: '100px' }} 
//         />
//         </div>
//         </div>
//       <div style={{ marginLeft: '10px', fontSize: '14px' }}>
//           {formatTime(currentTime)} / {formatTime(duration)}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AudioPlayer;



// import React, { useEffect, useRef, useState } from "react";
// import { Input } from "reactstrap";

// const AudioPlayer = (props) => {
//   const videoRef = useRef(null);
//   const audioRef = useRef(null);
//   const waveformRef = useRef(null);
//   const [currentEpoch, setCurrentEpoch] = useState(props.epochLength);
//   const [progress, setProgress] = useState(0);
//   const [duration, setDuration] = useState(null);


//   const handleWaveformClick = (event) => {
//     if (!audioRef.current || !waveformRef.current) return;
  
//     const rect = waveformRef.current.getBoundingClientRect();
//     const clickX = event.clientX - rect.left;
//     const clickPositionRatio = clickX / rect.width;
    
//     if (audioRef.current.duration) {
//       const newTime = clickPositionRatio * audioRef.current.duration;
//       audioRef.current.currentTime = newTime;
//       // audioRef.current.play();
//     }
//   };
  

//   const handleAudioPlay = () => {
//     if (videoRef.current) {
//       videoRef.current.play();
//     }
//   };

//   const handleAudioPause = () => {
//     if (videoRef.current) {
//       videoRef.current.pause();
//     }
//   };

//   const handleAudioEnded = () => {
//     if (videoRef.current) {
//       videoRef.current.pause();
//       videoRef.current.currentTime = 0; // Reset video to the beginning
//     }
//   };

//   useEffect(() => {
//     if (audioRef.current) {
//       audioRef.current.load();
//     }
//   }, [props.src]);

//   const handleTimeUpdate = () => {
//     if (audioRef.current) {
//       const currentTime = audioRef.current.currentTime;
//       const totalDuration = audioRef.current.duration;
//       if (totalDuration > 0) {
//         const newProgress = (currentTime / totalDuration) * 100;
//         setProgress(newProgress);
//       }
//       requestAnimationFrame(handleTimeUpdate);
//     }
//   };
  
//   const handleLoadedMetadata = () => {
//     if (audioRef.current) {
//       setDuration(audioRef.current.duration);
//     }
//   };

  
//   const hexToRgba = (hex, alpha) => {
//     let r = 0, g = 0, b = 0;
  
//     // Check for valid hex format
//     if (hex.startsWith("#")) {
//       if (hex.length === 4) {
//         r = parseInt(hex[1] + hex[1], 16);
//         g = parseInt(hex[2] + hex[2], 16);
//         b = parseInt(hex[3] + hex[3], 16);
//       } else if (hex.length === 7) {
//         r = parseInt(hex.slice(1, 3), 16);
//         g = parseInt(hex.slice(3, 5), 16);
//         b = parseInt(hex.slice(5, 7), 16);
//       }
//     }
  
//     return `rgba(${r}, ${g}, ${b}, ${alpha})`;
//   };



//   const generateTimeMarkers = () => {
//     if (!duration || duration <= 0) return null;
  
//     let totalMarkers = 10;
//     let stepSize = duration / totalMarkers;
  

//     if (stepSize > 0.9) stepSize = 2;
//     // else if (stepSize >= 1) stepSize = 20;
//     else if (stepSize > 0.3) stepSize = 1;
//     else if (stepSize > 0.1) stepSize = 0.5;
//     else stepSize = 0.1;
  
//     let markers = [];
//     let time = 0;
  
//     while (time <= duration) {
//       let roundedTime = Math.round(time * 10) / 10; // Ensure consistent rounding
  
//       // Ensure last marker always reaches the duration
//       if (time + stepSize > duration) roundedTime = duration;
  
//       const leftPosition = `${(roundedTime / duration) * 100}%`;
  
//       markers.push(
//         <div
//           key={roundedTime}
//           className="text"
//           style={{
//             position: "absolute",
//             left: leftPosition,
//             transform: "translateX(-50%)",
//             whiteSpace: "nowrap",
//           }}
//         >
//           {roundedTime}
//         </div>
//       );
  
//       time += stepSize; // Increment time using fixed step size
//     }
  
//     return markers;
//   };



//   const generateFrequencyMarkers = () => {
//     if (!waveformRef.current || !props.frequency_steps) return null;
  
//     const imgHeight = waveformRef.current.clientHeight;
//     const totalSteps = props.frequency_steps.length;
  
//     return props.frequency_steps.map((freq, index) => {
//       const topPosition = (index / (totalSteps )) * imgHeight + 12;
  
//       return (
//         <div
//           key={freq}
//           style={{
//             position: "absolute",
//             top: `${topPosition}px`,
//             left: 0,
//             fontSize: "12px",
//             // color: "white",
//             whiteSpace:'nowrap'
//           }}
//         >
//           {freq}
//         </div>
//       );
//     });
//   };


//   const generateColorFrequencyMarkers = () => {
//     if (!waveformRef.current || !props.color_bar) return null;
  
//     const imgHeight = waveformRef.current.clientHeight - 33;
//     const totalSteps = props.color_bar.length;
  
//     return props.color_bar.map((freq, index) => {
//       const topPosition = (index / (totalSteps )) * imgHeight + 36;
  
//       return (
//         <div
//           key={freq}
//           style={{
//             position: "absolute",
//             top: `${topPosition}px`,
//             right:-18,
//             // transform: "translateY(-50%)",
//             fontSize: "12px",
//             // color: "white",
//             whiteSpace:'nowrap'
//           }}
//         >
//           {freq} dB
//         </div>
//       );
//     });
//   };
  
  
  

//   return (
//     <div style={{ position: "relative", width: "100%", textAlign: "center" }}>
//       {props.showProperties === false && (
//         <div
//           className="d-flex grey-card_ align-items-center justify-content-between px-3 py-1 my-1"
//           style={{
//             position: "absolute",
//             top: -10,
//             zIndex: 9999,
//             overflow: "hidden",
//             width: "100%",
//           }}
//         >
//           <h6 className="mb-0 px-3 border-right d-flex align-items-center">
//             <p
//               className="notification-message mb-0"
//               style={{ display: "inline-block", whiteSpace: "nowrap" }}
//               title={props?.audioName}
//             >
//              {props?.audioName}
//             </p>
//           </h6>
//         </div>
//       )}

// <div>
// <div style={{ position: "relative", display: "flex" }}>
// {props.specView &&
//   <div style={{minWidth: "20px",  height: waveformRef.current?.clientHeight || "auto" }}>
//     {generateFrequencyMarkers()}
//   </div>}
//   <img
//     ref={waveformRef}
//     src={props.specView ? props?.spectrogram_url : props?.waveform_url}
//     style={{ maxWidth: "100%", display: "block", zIndex:'9'}}
//     alt="Waveform"
//     onClick={handleWaveformClick}
//   />
//   {props.specView &&
//   <div style={{minWidth: "20px",  height: waveformRef.current?.clientHeight || "auto" }}>
//     {generateColorFrequencyMarkers()}
//   </div>
// }
// </div>


// {!props.specView &&
// <div
//           style={{
//             position: "absolute",
//             top: 0,
//             left: `${progress}%`,
//             width: "3px",
//             height: waveformRef.current ? waveformRef.current.clientHeight : "100%",
//             backgroundColor: "var(--text-color)",
//             zIndex: 10,
//             transform: `translateX(${progress}%)`,
//             transition: "width 0.01s linear",
//           }}
//         />}
// {!props.specView &&
// <>
// {props.Groundtruth?.map((item, index) => {
//   const transparentColor = hexToRgba(item[5], props.value / 100);

//   return (
//     <div
//       key={index}
//       style={{
//         position: "absolute",
//         top: 0,
//         left: 0,
//         width: `${progress}%`,
//         height: waveformRef.current ? waveformRef.current.clientHeight : "100%",
//         background: transparentColor,
//         zIndex: 5,
//       }}
//       onClick={handleWaveformClick}
//     />
//   );
// })}
// </>}


// {/* {!props.specView &&
//   <>
//     {props.Groundtruth?.map((item, index) => {
//       const transparentColor = hexToRgba(item[5], 0.5);
//       const [start, end] = [item[0], item[1]]; // Assuming start and end times are in index 0 and 1
//       const left = (start / duration) * 100;
//       const width = ((end - start) / duration) * 100;

//       return (
//         <div
//           key={index}
//           style={{
//             position: "absolute",
//             top: 0,
//             left: `${left}%`,
//             width: `${width}%`,
//             height: waveformRef.current ? waveformRef.current.clientHeight : "100%",
//             background: transparentColor,
//             zIndex: 5,
//           }}
//         />
//       );
//     })}
//   </>
// } */}


// {/* {!props.specView && (
//   <>
//     {[
//       { start: 0.0, end: 0.3, color: "#ff000080" },
//       { start: 0.6, end: 1, color: "#00ff0080" },
//       { start: 1.5, end: 3, color: "#0000ff80" },
//     ].map((range, index) => (
//       <div
//         key={index}
//         style={{
//           position: "absolute",
//           top: 0,
//           left: `${(range.start / duration) * 100}%`,
//           width: `${
//             progress >= (range.end / duration) * 100
//               ? ((range.end - range.start) / duration) * 100
//               : (progress / 100) * duration > range.start
//               ? ((progress / 100) * duration - range.start) / duration * 100
//               : 0
//           }%`,
//           height: waveformRef.current
//             ? waveformRef.current.clientHeight
//             : "100%",
//           background: range.color,
//           zIndex: 5,
//           transition: "width 0.1s linear", // Smooth width expansion
//         }}
//       />
//     ))}
//   </>
// )} */}
// <div style={{ position: "relative", width: "89%", height: "40px", marginTop: "5px", margin:'auto' }}>
//           {generateTimeMarkers()}
//         </div>

// <div className="d-flex align-items-start flex-column">

// <div>
//         <audio
//           ref={audioRef}
//           // autoPlay
//           controls
//           onTimeUpdate={handleTimeUpdate}
//           onPlay={handleAudioPlay}
//           onPause={handleAudioPause}
//           onEnded={handleAudioEnded}
//           onLoadedMetadata={handleLoadedMetadata}
//         >
//           <source src={props.src} type="audio/wav" />
//           Your browser does not support the audio element.
//         </audio>
//       </div>

//           <div style={{textAlign:'left'}} className="pb-2 ps-1">
//             Ground truth
//           </div>
// <div className="py-2 d-a ps-1">
// {props.Groundtruth?.map((item, index) => (
//     <div
//     key={item[4]}
//       className="grey-card10 p-2 px-1 me-2"
//       style={{ minWidth: 80, position: "relative" }}
//     >
//       <div className="d-j-a">
//         <div
//           style={{
//             background: item[5],
//             padding: 7,
//             width: 5,
//             display: "inline-block",
//             borderRadius: 5,
//           }}
//         ></div>

//         <div className="h5 ms-2 mb-0"> {item[4]}</div>
//       </div>
//     </div>
//   ))
// }

//         {props.annotations && (
//           <div
//             className="d-flex align-items-center grey-card p-2 ms-2 pt-4"
//             style={{ minWidth: 120, position: "relative" }}
//           >
//             <div
//               style={{
//                 position: "absolute",
//                 fontSize: 12,
//                 top: 4,
//                 height: 10,
//                 left: 10,
//               }}
//             >
//               prediction
//             </div>
//             <div
//               style={{
//                 background:
//                   currentEpoch > 0
//                     ? props.annotations[currentEpoch][0][5]
//                     : props.annotations[0][5],
//                 padding: 7,
//                 width: 5,
//                 display: "inline-block",
//                 borderRadius: 5,
//               }}
//             ></div>
//             <div className="h4 ms-2">
//               {currentEpoch > 0
//                 ? props.annotations[currentEpoch][0][4]
//                 : props.annotations[0][4]}
//             </div>
//           </div>
//         )}
//       </div>
// </div>

// </div>

//       {props.epochLength > 1 && (
//         <div
//           className="d-flex grey-card align-items-center justify-content-between px-3 py-2 epoch"
//           style={{
//             position: "absolute",
//             bottom: 8,
//             right: 8,
//             zIndex: 9999,
//             overflow: "hidden",
//             width: 200,
//           }}
//         >
//           <div className="mx-3 my-2">
//             <label
//               htmlFor="customRange"
//               className="form-label"
//               style={{ fontSize: 10, position: "absolute", top: -7 }}
//             >
//               Epoch {currentEpoch} of {props.epochLength}
//             </label>
//             <Input
//               type="range"
//               className="form-range mt-2 pt-1"
//               min="0"
//               max={props.epochLength}
//               step={props.epochspacing ? props.epochspacing : 1}
//               id="customRange"
//               defaultValue={currentEpoch}
//               onChange={(e) => {
//                 setCurrentEpoch(e.target.value);
//               }}
//             ></Input>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AudioPlayer;




import { useEffect, useRef, useState } from 'react';
import WaveSurfer from 'wavesurfer.js';
import RegionsPlugin from 'wavesurfer.js/dist/plugins/regions.esm.js';
import SpectrogramPlugin from 'wavesurfer.js/dist/plugins/spectrogram.esm.js';
import Hover from 'wavesurfer.js/dist/plugins/hover.esm.js'
import TimelinePlugin from 'wavesurfer.js/dist/plugins/timeline.esm.js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPause, faPlay, faVolumeOff, faVolumeUp } from '@fortawesome/free-solid-svg-icons';
import { StyledTooltip } from '../../../views/project/label/annotation/EditorView/EditorTopNavigationBar/EditorTopNavigationBar';

const AudioPlayer = ({ audioUrl, value, Groundtruth }) => {
  const waveformRef = useRef(null);
  const spectrogramRef = useRef(null);
  const wsRef = useRef(null);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [volume, setVolume] = useState(1);
  const [zoomLevel, setZoomLevel] = useState(210);
  const [loader, setLoader] = useState(false)

  const hexToRgba = (hex, alpha) => {
    let r = 0, g = 0, b = 0;
  
    if (hex.startsWith("#")) {
      if (hex.length === 4) {
        r = parseInt(hex[1] + hex[1], 16);
        g = parseInt(hex[2] + hex[2], 16);
        b = parseInt(hex[3] + hex[3], 16);
      } else if (hex.length === 7) {
        r = parseInt(hex.slice(1, 3), 16);
        g = parseInt(hex.slice(3, 5), 16);
        b = parseInt(hex.slice(5, 7), 16);
      }
    }
  
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };


  useEffect(() => {
    if (!waveformRef.current || !audioUrl) return;
    setLoader (false)

    const ws = WaveSurfer?.create({
      container: waveformRef.current,
      waveColor: 'rgba(209, 209, 209, 0.74)',
      progressColor: '#8d8c8cd0',
      height: 200,
      url: audioUrl,
      sampleRate: 44100,
      dragToSeek: true,
      plugins: [
        TimelinePlugin.create(),
        Hover.create({
          lineColor: '#ff0000',
          lineWidth: 2,
          labelBackground: '#555',
          labelColor: '#fff',
          labelSize: '11px',
          formatTimeCallback: (time) => {
            const hours = Math.floor(time / 3600);
            const minutes = Math.floor((time % 3600) / 60);
            const seconds = Math.floor(time % 60);
            const pseudoMilliseconds = Math.floor((time % 1) * 100);
    
            return `${hours.toString().padStart(2, '0')}:` +
                   `${minutes.toString().padStart(2, '0')}:` +
                   `${seconds.toString().padStart(2, '0')}` 
                  //  `${pseudoMilliseconds.toString().padStart(2, '0')}`;
          }
        }),
      ]
    });
    

    wsRef.current = ws;

    

    ws.once("ready", () => {
      ws.zoom(zoomLevel);
    });

    // ---------- time ------ //

  ws.once('ready', () => {
    setDuration(ws.getDuration());
  });

  ws.on('audioprocess', () => {
    setCurrentTime(ws.getCurrentTime());
  });



    const regions = ws.registerPlugin(RegionsPlugin.create());
    ws.registerPlugin(
      SpectrogramPlugin.create({
        container: spectrogramRef.current,
        labels: true,
        height: 250,
        scale: 'mel',
        frequencyMax: 8000,
        frequencyMin: 0,
        fftSamples: 1024,
        labelsBackground: 'rgba(0, 0, 0, 0.1)'
      })
    );

    // ws.once('decode', () => {    
    //   const regionsData = Groundtruth?.map(item => ({
    //     start: item[0],
    //     end: item[1],
    //     content: item[4],
    //     color: hexToRgba(item[5], value / 100),
    //     resize: false,
    //     drag: false
    //   }));
    
    //   regionsData?.forEach(region => regions.addRegion(region));
    // });



    ws.on('decode', () => {
      regions.addRegion({
        start: 0.00,
        end: 0.77,
        content: 'Laugh',
        color: '#ff000070',
        drag: false,
        resize: false,
      })
      regions.addRegion({
        start: 0.83,
        end: 3.27,
        content: 'Talk',
        color: '#ffa50047',
        resize: false,
      })
      regions.addRegion({
        start: 3.31,
        end: 3.51,
        content: 'Cry',
        color: '#00800054',
        resize: false,
      })
      regions.addRegion({
        start: 3.63,
        end: 6.01,
        content: 'Talk',
        color: '#ffa50047',
        resize: false,
      })
      regions.addRegion({
        start: 6.05,
        end: 6.25,
        content: 'Cry',
        color: '#00800054',
        resize: false,
      })
        regions.addRegion({
        start: 6.30,
        end: 6.98,
        content: 'Silence',
        color: '#a52a2a4d',
        minLength: 1,
        maxLength: 10,
        resize: false,
      })
    })
    

    ws.on('finish', () => {
      setIsPlaying(false);
      ws.setTime(0);
    });

    return () => {
      ws.destroy();
    };
  }, [audioUrl, value]);

  const togglePlay = () => {
    if (wsRef.current) {
      wsRef.current.playPause();
      setIsPlaying(!isPlaying);
    }
  };

  const toggleMute = () => {
    if (wsRef.current) {
      if (isMuted) {
        wsRef.current.setVolume(1);
      } else {
        wsRef.current.setVolume(0);
      }
      setIsMuted(!isMuted);
    }
  };

  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    if (wsRef.current) {
      wsRef.current.setVolume(newVolume);
    }
  };


  // --------------- time ----------- //

  const formatTime = (time) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = Math.floor(time % 60);
    const pseudoMilliseconds = Math.floor((time % 1) * 100);

    return `${hours.toString().padStart(2, '0')}:` +
           `${minutes.toString().padStart(2, '0')}:` +
           `${seconds.toString().padStart(2, '0')}` 
          //  `${pseudoMilliseconds.toString().padStart(2, '0')}`;
  }




  const zoomIn = () => {
    let newZoomLevel = Math.min(zoomLevel + 100, 500);
    setZoomLevel(newZoomLevel);
    if (wsRef.current) {
      wsRef.current.zoom(newZoomLevel);
    }
  };

  const zoomOut = () => {
    let newZoomLevel = Math.max(zoomLevel - 100, 200);
    setZoomLevel(newZoomLevel);
    if (wsRef.current) {
      wsRef.current.zoom(newZoomLevel);
    }
  };


  return (
    <div className='d-flex flex-column w-100 p-4 px-1'>
      <div ref={waveformRef} id="waveform" style={{ width: '100%', maxHeight: '300px' }} className='my-4 pt-4'></div>
      <div ref={spectrogramRef} id="spectrogram" style={{ width: '100%'}}></div>
      <div className="mt-3 d-a justify-content-between w-100">
        <div className='d-a'>
        <button onClick={togglePlay} className='plain-button2 me-4'>{isPlaying ? <FontAwesomeIcon icon={faPause} /> : <FontAwesomeIcon icon={faPlay} />}</button>
        <div className='d-a custom-hover'>
        <button onClick={toggleMute} className='plain-button2'>{isMuted ? <FontAwesomeIcon icon={faVolumeOff} /> : <FontAwesomeIcon icon={faVolumeUp} />}</button>
        <input 
        className='custom-visible'
          type="range" 
          min="0" 
          max="1" 
          step="0.01" 
          value={isMuted ? 0 : volume} 
          onChange={handleVolumeChange} 
          style={{ width: '100px' }} 
        />
        </div>

        </div>
      <div style={{ marginLeft: '10px', fontSize: '14px' }}>
        {/* <StyledTooltip title='Zoom out'>
        <button onClick={zoomOut} className='plain-button2 border me-2' style={{borderRadius:'5px'}}>
          -
          </button>
          </StyledTooltip>
          <StyledTooltip title='Zoom in'>
          <button onClick={zoomIn} className='plain-button2 border me-2' style={{borderRadius:'5px'}} >
         +
          </button>
          </StyledTooltip> */}
          {formatTime(currentTime)} / {formatTime(duration)}
        </div>
      </div>
    </div>
  );
};

export default AudioPlayer;